const serviceFeatureMap = {
    Gstsearch: "GST",
    GstRefresh: "GST",

    Cinsearch: "CIN",
    CinRefresh: "CIN",

    Dinsearch: "DIN",
    DinMoblieEmail: "DIN",

    Iecsearch: "IEC",

    Msmesearch: "MSME",
    MsmeRefresh: "MSME",

    Pansearch: "PAN",
    BusinessPansearch: "PAN",
    PanRefresh: "PAN",

    Madsearch: "MAD",

    Mobile360search: "Mobile360",
    MultipleUPI: "Mobile360",

    InfoByPhonesearch: "OSINT",
    InfoMoreByPhonesearch: "OSINT",
    InfoByEmailsearch: "OSINT",
    InfoMoreByEmailsearch: "OSINT",

    Darpansearch: "DARPAN",

    Mcasearch: "MCA"
};
export { serviceFeatureMap }